import { DateHelper } from "utils/helpers";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";

/**
 * @deprecated This service is deprecated. Move utility functions to utils/helpers.
 *
 * Migration guide:
 * 1. Move pure utility functions to appropriate helper files (e.g., DateHelper, MathHelper)
 * 2. Convert state-dependent functions to custom hooks
 * 3. Use Redux hooks for state management
 *
 * @see utils/helpers/ - Directory containing utility functions
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */

const BankPaymentInformationService = {
  getPayout: (bankPaymentInformation?: ApiModels.BankPaymentInformation) => {
    if (bankPaymentInformation === undefined) return 0;
    let totalAmount = 0;

    bankPaymentInformation.incomingInvoicePaymentFilesToSign?.forEach((bankPayment) => {
      if (bankPayment.amount?.value) totalAmount = totalAmount + bankPayment.amount.value;
    });

    bankPaymentInformation.incomingInvoiceManualPayments?.forEach((bankPayment) => {
      if (bankPayment.amount?.value) totalAmount = totalAmount + bankPayment.amount.value;
    });

    bankPaymentInformation.salaryPayoutFilesToSign?.forEach((bankPayment) => {
      if (bankPayment.amount?.value) totalAmount = totalAmount + bankPayment.amount.value;
    });

    bankPaymentInformation.receiptPayoutFilesToSign?.forEach((bankPayment) => {
      if (bankPayment.amount?.value) totalAmount = totalAmount + bankPayment.amount.value;
    });

    bankPaymentInformation.manualPayoutsToSign?.forEach((bankPayment) => {
      if (bankPayment.amount?.value) totalAmount = totalAmount + bankPayment.amount.value;
    });

    return totalAmount;
  },
  getDueDate: (bankPaymentInformation?: ApiModels.BankPaymentInformation) => {
    if (bankPaymentInformation === undefined) return new Date();
    let dueDate = DateHelper.getDateMax();

    bankPaymentInformation.incomingInvoicePaymentFilesToSign?.forEach((payout) => {
      payout.incomingInvoicePayments?.forEach((x) => {
        const dueOrPaymentDate = x.dueDate ?? x.paymentDate;
        if (dueOrPaymentDate && DateHelper.isBefore(new Date(dueOrPaymentDate), dueDate)) dueDate = dueOrPaymentDate;
      });
    });

    bankPaymentInformation.incomingInvoiceManualPayments?.forEach((payout) => {
      const payoutDueDate = payout.dueDate ?? payout.paymentDate;
      if (payoutDueDate && DateHelper.isBefore(new Date(payoutDueDate), dueDate)) dueDate = payoutDueDate;
    });

    bankPaymentInformation.salaryPayoutFilesToSign?.forEach((payout) => {
      if (payout.date && DateHelper.isBefore(new Date(payout.date), dueDate)) dueDate = payout.date;
    });

    bankPaymentInformation.receiptPayoutFilesToSign?.forEach((payout) => {
      if (payout.date && DateHelper.isBefore(new Date(payout.date), dueDate)) dueDate = payout.date;
    });

    bankPaymentInformation.manualPayoutsToSign?.forEach((payout) => {
      if (payout.date && DateHelper.isBefore(new Date(payout.date), dueDate)) dueDate = payout.date;
    });

    return dueDate;
  },
  getNumOfPayments: (bankPaymentInformation?: ApiModels.BankPaymentInformation) => {
    if (bankPaymentInformation === undefined) return 0;

    return (
      (bankPaymentInformation.incomingInvoicePaymentFilesToSign?.length ?? 0) +
      (bankPaymentInformation.incomingInvoiceManualPayments?.length ?? 0) +
      (bankPaymentInformation.salaryPayoutFilesToSign?.length ?? 0) +
      (bankPaymentInformation.receiptPayoutFilesToSign?.length ?? 0) +
      (bankPaymentInformation.manualPayoutsToSign?.length ?? 0)
    );
  },
};

export default BankPaymentInformationService;
